import React from "react";
import PropTypes from "prop-types";
import Service from "../Service";
import "../../css/Cards/CardServices.css";

/**
 * CardServices component
 */
class CardServices extends React.Component {
  static displayName = "CardServices";
  static propTypes = {
    className: PropTypes.string,
    currentPage: PropTypes.object.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CardServices";
  }

  /**
   * @override
   */
  render() {
    const page = this.props.currentPage;
    const services = page.services();
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__title`}>
          {page.ServiceCardTitle}
        </div>
        <div className={`${this.className}__services`}>
          {services.map((service) => (
            <Service key={service.ID} service={service} {...this.props} />
          ))}
        </div>
      </div>
    );
  }
}

export default CardServices;



// WEBPACK FOOTER //
// ./src/components/Cards/CardServices.js